/* eslint-disable */
var iOS = parseFloat(
	('' + (/CPU.*OS ([0-9_]{1,5})|(CPU like).*AppleWebKit.*Mobile/i.exec(navigator.userAgent) || [0,''])[1])
	.replace('undefined', '3_2').replace('_', '.').replace('_', '')
) || false;
/* eslint-enable */

let canRun = !iOS || (iOS >= 11)

export const hasPerf = canRun



// WEBPACK FOOTER //
// ./src/components/DOM/Perf.js